import { render, staticRenderFns } from "./ProfessionalItem.vue?vue&type=template&id=7365a075"
import script from "./ProfessionalItem.vue?vue&type=script&lang=js"
export * from "./ProfessionalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports